<template>
<!--  <el-table :data="getTable" stripe style="width: 100%">
    <el-table-column prop="name" label="Название" width="180" />
    <el-table-column prop="authors_str" label="Авторы" width="180" />
    <el-table-column label="Ссылки">
      <template #default="scope">
        <el-button size="small" @click="download(scope.row.id,'epub')">
          epub
        </el-button>
        <el-button size="small" @click="download(scope.row.id,'fb2')">
          fb2
        </el-button>
        <el-button size="small" @click="download(scope.row.id,'mobi')">
          mobi
        </el-button>
      </template>
    </el-table-column>
  </el-table>-->
  <template v-for="item in getTable" :key="item.id">
  <el-card style="max-width: 480px">
    <p><strong>{{item.name}}</strong></p>
    <p><strong style="font-size:10px;">{{item.authors_str}}</strong>
    </p>
    <p>id:{{item.id}}</p>
    <el-button size="small" @click="download(item.id,'epub',item.name)">
      epub
    </el-button>
    <el-button size="small" @click="download(item.id,'fb2',item.name)">
      fb2
    </el-button>
    <el-button size="small" @click="download(item.id,'mobi',item.name)">
      mobi
    </el-button>
  </el-card>
  </template>
</template>
<script>
import axios from "axios";
import { ElMessage } from 'element-plus'

export default {
  name: "DataTable",
  data() {
    return {
      data: this.tableData,
    }
  },
  props: {
    tableData: Array,
  },
  methods: {
    genLink: function (id,type) {
      return process.env.VUE_APP_URL+'/send/:id/:format'.replace(":id",id).replace(":format",type);
    },
    genLinkStr: function(item) {
      return '<a href="'+this.genLink(item.book.id,'epub')+'">epub</a>'+
          '<a href="'+this.genLink(item.book.id,'fb2')+'">fb2</a>'+
          '<a href="'+this.genLink(item.book.id,'mobi')+'">mobi</a>';
    },
    getAuthors: function(item) {
      const authors=item.authors.map(o=>o.name);
      return authors.join(", ");
    },
    download: function(id,type,name) {
      axios.post(this.genLink(id,type),{initData:window.Telegram.WebApp.initData,filename:name},)
          .then(response => {
            //{ responseType: 'blob' }
           /* let fileUrl = window.URL.createObjectURL(response.data);
            let fileLink = document.createElement('a');

            fileLink.href = fileUrl;
            fileLink.setAttribute('download', id+'.'+type);
            document.body.appendChild(fileLink)

            fileLink.click();

            */
            if (response.data.status && response.data.status=='ok')
            {
              ElMessage({message:'Книга загружается. Проверьте бота.',    type: 'success',})
            }
          }).catch(error => {
        console.log(error.response.data)
      })


    }
  },
  watch: {
    tableData: function (newV) {
      this.data=newV;
    },
  },
  computed: {
    getTable : function () {
      return this.data.map(item=>({
            id: item.book.id,
            name: item.book.name,
            authors_str: this.getAuthors(item),
            links: this.genLinkStr(item)
          }
      ))
    },
  }
};
</script>
